<script lang="ts">
  import {createEventDispatcher, onDestroy, onMount} from 'svelte';
  import {Video} from '../highlight-recap-subtitles/Video';
  import {VideoControls} from '@/components';
  import Composition from './Composition.svelte';
  import {currentFrame, VideoTimeStamp} from '@/store/recap';
  // import { fps } from "./RemotionElements/Util";
  import {recap} from '@/store';
  // import { compositionGenerator } from "./CompositionBuilder";

  const dispatch = createEventDispatcher();

  let intializeComposition = (video: HTMLVideoElement) => {}; // placeholder ;

  export let videoSrc = '';
  export let timestamps: VideoTimeStamp[] = [];

  let videoElement: HTMLVideoElement;
  let video: Video;
  let progress = 0;

  export let isBuffering = false;

  let fps = 30;

  const recapSubscription = recap.subscribe(value => {
    fps = value.videoConfig.fps;
  });

  onMount(() => {
    currentFrame.set(0);
    video = new Video(videoElement, [], fps);

    video.setNewTimestamps(timestamps);
    duration = video.duration();

    // recap.update((value) => {
    // 	if (value.composition && value.composition.length > 0) return value;
    // 	if (value.videoConfig) return value;

    // 	const payload = compositionGenerator({
    // 		baseHeight : 1080,
    // 		baseWidth : 1920,
    // 		fps,
    // 		timestamps : [...(value.intro_timestamps || []), ...(value.timestamps || [])],
    // 		transcription : value.transcription || [],
    // 		logoSrc : "https://media.istockphoto.com/photos/leaf-picture-id500613911?k=6&m=500613911&s=170667a&w=0&h=rblfTXa41rKe9K4pcZ0MiFelTyc6FucPIStXbayzWO0=",
    // 	});

    // 	value.composition = payload.composition;
    // 	value.videoConfig = payload.videoConfig;

    // 	return value;
    // })

    intializeComposition(videoElement);

    video.onTimeupdate(event => {
      dispatch('timeupdate', event);

      if (isBuffering) isBuffering = false;
      if (!progressBar) return;

      let bar = progressBar.getProgressElement();
      bar.value = (event.currentTime / duration) * 100;
      progress = bar.value;

      progressBar.changeRunnerColor(bar);
    });

    video.onFrameupdate((currentTime, frame) => {
      // console.log(frame, "frame");
      currentFrame.set(frame);
    });

    video.onBuffering(() => {
      // console.log("isBuffering");
      isBuffering = true;
    });
  });

  let progressBar: any;
  let duration = 0;

  function stopVideo() {
    video.stop();
  }

  function playVideo() {
    video.play();
  }

  function pauseVideo() {
    video.pause();
  }

  function seekTimeline(event: any) {
    video.seek(video.duration() * (event.detail.value / 100));
  }

  onDestroy(() => {
    video.destroy();
    recapSubscription();
  });
</script>

<div class="flex h-full w-full flex-grow justify-center overflow-hidden">
  <div class="relative flex w-full flex-col items-center justify-center pb-16">
    <div class="w-full p-6" style="max-height: 100%; max-width: 1800px">
      <div class="relative flex max-h-full max-w-full">
        <!-- svelte-ignore a11y-media-has-caption -->
        <video bind:this={videoElement} class="rounded-lg" controls={false} src={videoSrc}></video>
        <Composition bind:intializeComposition />
        {#if isBuffering}
          <div class="absolute left-0 top-0 h-full w-full px-5 py-2.5">
            <div style="background: rgba(0,0,0,0.5);" class="h-full w-full"></div>
          </div>
          <div class="absolute left-0 top-0 flex h-full w-full items-center justify-center">
            <img
              src="https://storage.googleapis.com/sermonshots-homepage/v2/images/sermonshot-loader.gif"
              alt="loader"
            />
          </div>
        {/if}
      </div>
    </div>
    <div class="absolute bottom-0 w-full">
      <VideoControls
        bind:progressBar
        bind:progress
        showDuration={true}
        on:stop-video={stopVideo}
        on:play-video={playVideo}
        on:pause-video={pauseVideo}
        on:seek-timeline={seekTimeline}
        bind:duration
      />
    </div>
  </div>
</div>
